var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStacklogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_01:_600_x_600_px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:-.08em;}.cls-2{fill:#ea843f;}.cls-3,.cls-4{fill:#397ed1;}.cls-4{font-family:HiraKakuStdN-W8-83pv-RKSJ-H, 'Hiragino Kaku Gothic StdN';font-size:72px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.33 205.62 247.58 288.35 403.83 114.48 191.33 205.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "398.72 292.74 342.47 210.01 186.22 383.88 398.72 292.74"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(155.91 468.62)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 55.01,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 104.9,
    y: 0
  }, "ACK")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStacklogo);
export default __webpack_public_path__ + "static/media/stacklogo.0ae7f1536beb323cfc201909730959ef.svg";
export { ForwardRef as ReactComponent };